"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
const cryptoService_1 = require("./service/cryptoService");
const stellarService_1 = require("./service/stellarService");
exports.convertTfAccount = (seedPhrase, walletAmount = 1, startIndex = 1) => __awaiter(void 0, void 0, void 0, function* () {
    for (let i = 0; i < walletAmount; i++) {
        const walletEntropy = cryptoService_1.calculateWalletEntropyFromAccount(seedPhrase, startIndex + i);
        const stellarPair = cryptoService_1.keypairFromAccount(walletEntropy);
        const revinePair = cryptoService_1.revineAddressFromSeed(seedPhrase, startIndex + i);
        yield stellarService_1.migrateAccount(stellarPair, revinePair);
    }
});
__export(require("./service/cryptoService"));
__export(require("./service/lockService"));
__export(require("./service/rivineService"));
__export(require("./service/stellarService"));
__export(require("./service/fundService"));
__export(require("./service/vestingService"));
__export(require("./service/bscService"));
__export(require("./service/trustlineService"));
__export(require("./service/priceService"));
__export(require("./service/tradeService"));
//# sourceMappingURL=index.js.map